export const PageHeader = ({ title, subtitle, action }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
    <div>
      <h1 className="font-display text-3xl sm:text-4xl font-semibold">{title}</h1>
      {subtitle && <p className="text-muted-foreground mt-1">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export const StatusBadge = ({ status }) => {
  const map = {
    pending: { label: "Bekliyor", cls: "bg-amber-500/15 text-amber-400" },
    paid: { label: "Ödendi", cls: "bg-emerald-500/15 text-emerald-400" },
    cleared: { label: "Tahsil Edildi", cls: "bg-emerald-500/15 text-emerald-400" },
    bounced: { label: "Karşılıksız", cls: "bg-rose-500/15 text-rose-400" },
  };
  const s = map[status] || { label: status, cls: "bg-secondary text-muted-foreground" };
  return <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${s.cls}`}>{s.label}</span>;
};

export const EmptyState = ({ icon: Icon, title, desc }) => (
  <div className="flex flex-col items-center justify-center py-20 text-center border border-dashed border-border rounded-lg noise-bg">
    {Icon && <Icon size={40} className="text-muted-foreground mb-4" />}
    <p className="font-medium">{title}</p>
    {desc && <p className="text-sm text-muted-foreground mt-1 max-w-xs">{desc}</p>}
  </div>
);
